const ar = {
  loginTitle: 'تسجيل الدخول',
  loginPlaceholderID: 'رقم الهوية',
  loginPlaceholderPassword: 'كلمة المرور',
  loginPlaceholderEmail: 'البريد الإليكتروني',
  loginBtn: 'تسجيل الدخول',
  loginGetPassocdeBtn: 'إحصل على كلمة مرور',
  loginGetPassocde: 'الحصول على كلمة مرور مؤقته',
  loginGoToLogin: 'الرجوع إلى تسجيل الدخول',
  // welcome page
  WelcomeMassage: 'اهلاً وسهلاً',
  Welcome1Massage: 'يسعدنا رؤيتك',
  //comleted page
  Thankyou: 'تم ارسال الاستبيان الخاص بك بنجاح',
  Back: 'الرجوع',
}

export default ar
